import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Bell, X, Clock, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const NotificationPopup = ({ notifications, onMarkAsRead, onDelete, onClose }) => {
  const navigate = useNavigate();
  const unreadNotifications = notifications.filter(n => !n.read);

  const handleNotificationClick = (notification) => {
    // Mark as read
    onMarkAsRead(notification.id);

    // Navigate if it's a task overdue notification
    if (notification.type === 'task_overdue' && notification.data?.checklist_date) {
      navigate('/checklist');
      onClose();
    }
  };

  if (unreadNotifications.length === 0) {
    return null;
  }

  return (
    <Dialog open={unreadNotifications.length > 0} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Bell className="h-5 w-5 text-purple-600" />
            Notifications ({unreadNotifications.length})
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3 max-h-96 overflow-y-auto">
          {unreadNotifications.map((notification) => (
            <div
              key={notification.id}
              className="border rounded-lg p-3 hover:bg-gray-50 cursor-pointer transition-all"
              onClick={() => handleNotificationClick(notification)}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    {notification.type === 'task_overdue' && (
                      <Clock className="h-4 w-4 text-red-500" />
                    )}
                    <h4 className="font-semibold text-sm">{notification.title}</h4>
                  </div>
                  <p className="text-sm text-gray-600">{notification.message}</p>
                  <p className="text-xs text-gray-400 mt-1">
                    {new Date(notification.created_at).toLocaleTimeString()}
                  </p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(notification.id);
                  }}
                  className="ml-2"
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="flex gap-2">
          <Button
            onClick={() => {
              unreadNotifications.forEach(n => onMarkAsRead(n.id));
            }}
            variant="outline"
            size="sm"
            className="flex-1"
          >
            <CheckCircle className="h-4 w-4 mr-1" />
            Mark All as Read
          </Button>
          <Button
            onClick={onClose}
            size="sm"
            className="flex-1"
            style={{ backgroundColor: "#652D90" }}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
